import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { SquareFootage } from 'domain/listing/value-objects';
import { Namespaces } from 'types/locales';
import { formatSquareFootage } from './format-square-footage';

export interface UseSquareFootageOptions {
  squareFootage: { min: number; max: number } | null;
}

export interface UseSquareFootageResult {
  formatted: string;
  hasValue: boolean;
}

export function useSquareFootage(options: UseSquareFootageOptions): UseSquareFootageResult {
  const { squareFootage } = options;
  const { t } = useTranslation(Namespaces.COMMON);

  return useMemo(() => {
    const vo = SquareFootage.from(squareFootage);
    return {
      formatted: formatSquareFootage(vo, t),
      hasValue: vo.hasValue,
    };
  }, [squareFootage, t]);
}
